module.exports = __webpack_public_path__ + "static/media/Pricing.ed7f2205.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Icons/Pricing.svg
// module id = 1281
// module chunks = 0